module.exports = __webpack_public_path__ + "img/target_symbol_red.1bc89989.svg";